import moment from 'moment'
import _ from 'lodash'
let estadoNominas = [
    '-',                // 0 - nunca ocurre
    'Deshabilitada',    // 1 - Deshabilitada
    'Pendiente',        // 2 - Pendiente
    'Recibida',         // 3 - Recibida
    'Aprobada',         // 4 - Aprobada
    'Informada',        // 5 - Informada
    'Inform. Excel'   // 6 - Informada con Excel (plataforma antigua)
]
let estadoConteo = [
    'Sin Calificación',
    'Peligro',
    'Precaución',
    'Óptima',
    'Sobre Dotación',
    'Sobre Dotación Alta'
]

export default class BlackBoxIGSemanal {
    constructor() {
        this.lista = []
        this.filtroRegiones = []
        this.filtroComunas = []
        this.filtroTurnos = []
        this.filtroLideres = []
        this.filtroSupervisores = []
        this.filtroCaptadores = []
        this.filtroCeco = []
        this.filtroFechas = []
        this.filtroHoraLider = []
        this.filtroNominas = []
        this.filtroClientes = []
        this.filtroNominasEstado = []
        this.filtroAsistencia = []
        this.filtroEgreso = []
        this.filtroUnidades = []
        this.filtroSuspendidos = []
    }
    reset() {
        this.lista = []
        this.filtroRegiones = []
        this.filtroComunas = []
        this.filtroTurnos = []
        this.filtroLideres = []
        this.filtroSupervisores = []
        this.filtroCaptadores = []
        this.filtroCeco = []
        this.filtroFechas = []
        this.filtroHoraLider = []
        this.filtroNominas = []
        this.filtroClientes = []
        this.filtroNominasEstado = []
        this.filtroAsistencia = []
        this.filtroEgreso = []
        this.filtroUnidades = []
        this.filtroSuspendidos = []
    }
    // Todo: Optimizar
    // Todo Modificar: el listado de clientes
    add(inventario) {
        this.lista.push(inventario)
    }

    // Todo modificar el listado de clientes
    actualizarInventario(inventarioActualizado) {
        this.lista = this.lista.map(inventario => {
            if (inventario.inv_idInventario == inventarioActualizado.inv_idInventario) {
                return inventarioActualizado
            }
            return inventario
        })
        this.actualizarFiltros()
    }

    /*** ################### FILTROS ################### ***/
    ordenarLista() {
        let porFechaProgramada = (inventario) => {
            let dateA = new Date(inventario.inv_fechaProgramada)
            if (dateA == 'Invalid Date') {
                let [annoA, mesA, diaA] = inventario.inv_fechaProgramada.split('-')
                // OJO: (new Date('2016-04')) - (new Date('2016-03-31')), resulta en 0, y los ordena mal, por eso se resta 1
                return new Date(`${annoA}-${mesA}`) - 1
            } else {
                return dateA
            }
        }
        let porCliente = (inventario) => inventario.cliente_idCliente
        let porStockTeorico = (inventario) => inventario.inv_stockTeorico

        // ordenar por fechaprogramada, y por stock
        this.lista = _.orderBy(this.lista, [porFechaProgramada, porCliente, porStockTeorico], ['asc', 'asc', 'desc'])
    }

    actualizarFiltros() {
        // ##### Filtro fechas
        this.filtroFechas = _.chain(this.lista)
            .map(inventario => {
                let momentFecha = moment(inventario.inv_fechaProgramada)
                let valor = inventario.inv_fechaProgramada
                let texto = momentFecha.isValid() ? momentFecha.format('dddd DD MMMM') : `-- ${inventario.inv_fechaProgramada} --`

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroFechas, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()

        // ##### Filtro Regiones
        this.filtroRegiones = _.chain(this.lista)
            .map(inventario => {
                let valor = inventario.local_cutRegion
                let texto = inventario.local_region

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroRegiones, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy('valor')    // ordenado por numero de region
            .value()

        // ##### Filtro Comunas (ordenado por codComuna)
        this.filtroComunas = _.chain(this.lista)
            // solo dejar las comunas en las que su respectiva region este seleccionada
            .filter(inventario => {
                return _.find(this.filtroRegiones, { 'valor': inventario.local_cutRegion, 'seleccionado': true })
            })
            .map(inventario => {
                let valor = inventario.local_cutComuna
                let texto = inventario.local_comuna

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroComunas, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        // ##### Filtro Turnos
        this.filtroTurnos = _.chain(this.lista)
            .map(inventario => {
                let valor = inventario.inv_idJornada
                let texto = inventario.inv_jornada

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroTurnos, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        this.filtroEgreso = _.chain(this.lista)
            .map(inventario => {
                let valor = inventario.store_departureTime
                let texto = inventario.store_departureTime
                let opcion = _.find(this.filtroEgreso, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        this.filtroUnidades = _.chain(this.lista)
            .map(inventario => {
                let valor = inventario.inv_unidadesReales > 0 ? 'Tiene Conteo' : 'Sin Conteo'
                let texto = inventario.inv_unidadesReales > 0 ? 'Tiene Conteo' : 'Sin Conteo'
                let opcion = _.find(this.filtroUnidades, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        // ##### Filtro Lideres, considerar el lider solo si la jornada de la nomina se encuentra activa
        let lideresDia = _.chain(this.lista)
            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4'))
            .map(inventario => {

                let valor = inventario.ndia_idLider
                let texto = inventario.ndia_lider       //'-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroLideres, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        let lideresNoche = _.chain(this.lista)
            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4'))
            .map(inventario => {
                let valor = inventario.nnoche_idLider
                let texto = inventario.nnoche_lider     //  '-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroLideres, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
        this.filtroLideres = _.chain(lideresDia)
            .unionBy(lideresNoche, 'valor')
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        // ##### Filtro horaLider
        let hrsLiderDia = _.chain(this.lista)
            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4'))
            .map(inventario => {

                let valor = inventario.ndia_hrLider
                let texto = inventario.ndia_hrLider     //'-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroHoraLider, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        let hrsLiderNoche = _.chain(this.lista)
            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4'))
            .map(inventario => {
                let valor = inventario.nnoche_hrLider
                let texto = inventario.nnoche_hrLider     //  '-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroHoraLider, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
        this.filtroHoraLider = _.chain(hrsLiderDia)
            .unionBy(hrsLiderNoche, 'valor')
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        // ##### Filtro Supervisores, considerar el supervisor solo si la jornada de la nomina se encuentra activa
        let supervisoresDia = _.chain(this.lista)
            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4'))
            .map(inventario => {

                let valor = inventario.ndia_idSupervisor
                let texto = inventario.ndia_supervisor       //'-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroSupervisores, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        let supervisoresNoche = _.chain(this.lista)
            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4'))
            .map(inventario => {
                let valor = inventario.nnoche_idSupervisor
                let texto = inventario.nnoche_supervisor     //  '-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroSupervisores, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
        this.filtroSupervisores = _.chain(supervisoresDia)
            .unionBy(supervisoresNoche, 'valor')
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        // ##### Filtro Captador, considerar el lider solo si la jornada de la nomina se encuentra activa
        //const reducer = (previousValue, currentValue) => previousValue.concat(currentValue);

        let captadoresDia = _.chain(this.lista)
            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4'))
            .flatMap(inventario => inventario.ndia_captadores)
            .uniqBy('idUsuario')
            .map((captador) => {
                let valor = captador.idUsuario;
                let texto = captador.nombre;     // '-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroCaptadores, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        let captadoresNoche = _.chain(this.lista)
            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4'))
            .flatMap(inventario => {
                //let valor = inventario.nnoche_idCaptador1
                //let texto = inventario.nnoche_captador1     // '-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                //let opcion = _.find(this.filtroCaptadores, {'valor': valor})
                //return opcion? opcion : {valor, texto, seleccionado: true}
                return inventario.nnoche_captadores;
            })
            .uniqBy('idUsuario')
            .map((captador) => {
                let valor = captador.idUsuario;
                let texto = captador.nombre;     // '-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroCaptadores, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
        this.filtroCaptadores = _.chain(captadoresDia)
            .unionBy(captadoresNoche, 'valor')
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        // ##### Filtro Numero de Local
        this.filtroCeco = _.chain(this.lista)
            .map(auditoria => {
                let valor = '' + auditoria.local_ceco
                let texto = '' + auditoria.local_ceco // debe ser un string

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroCeco, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy(op => op.valor.length, 'valor') // ordenar primero los numeros de dos digitos, luego los de 3 digitos...
            .value()

        let nominasDia = _.chain(this.lista)
            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4'))
            .map(inventario => {

                let valor = inventario.ndia_idEstadoNomina
                let texto = estadoNominas[inventario.ndia_idEstadoNomina]      //'-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroNominas, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        let nominasNoche = _.chain(this.lista)
            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4'))
            .map(inventario => {
                let valor = inventario.nnoche_idEstadoNomina
                let texto = estadoNominas[inventario.nnoche_idEstadoNomina]     //  '-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroNominas, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
        this.filtroNominas = _.chain(nominasDia)
            .unionBy(nominasNoche, 'valor')
            .uniqBy('valor')
            .sortBy('valor')
            .value()

        // ###### Filtro estado de nominas
        let nominasDiaEstado = _.chain(this.lista)
            // considerar la nomina de dia solo cuando la jornada sea 'dia (2)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '2' || inventario.inv_idJornada == '4'))
            .map(inventario => {

                let valor = inventario.ndia_calificacionNomina
                let texto = estadoConteo[inventario.ndia_calificacionNomina]      //'-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroNominasEstado, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        let nominasNocheEstado = _.chain(this.lista)
            // considerar la nomina de noche solo cuando la jornada sea 'noche (3)' o 'dia y noche (4)'
            .filter(inventario => (inventario.inv_idJornada == '3' || inventario.inv_idJornada == '4'))
            .map(inventario => {
                let valor = inventario.nnoche_calificacionNomina
                let texto = estadoConteo[inventario.nnoche_calificacionNomina]     //  '-- NO ASIGNADO --'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroNominasEstado, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .value()
        // unir ambos arreglos, sacar los repetidos, y ordenar por nombre
        this.filtroNominasEstado = _.chain(nominasDiaEstado)
            .unionBy(nominasNocheEstado, 'valor')
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        let filtroAnterior = this.filtroAsistencia;
        this.filtroAsistencia = _.chain(this.lista)
            .map(inventario => {
                let titularesDia = inventario.ndia_totalTitulares
                    .filter(row => !row.lider);
                let titularesNoche = inventario.nnoche_totalTitulares
                    .filter(row => !row.lider);
                console.log('titularesDia', titularesDia)
                console.log('titularesNoche', titularesNoche)
                let status_asistencia_global_dia = titularesDia.length !== 0 ?
                    titularesDia.every(row => row.estado_asistencia >= 3)
                    : false;
                let status_asistencia_global_noche = titularesNoche.length !== 0 ?
                    titularesNoche.every(row => row.estado_asistencia >= 3)
                    : false;

                let status_asistencia_global =
                    inventario.inv_idJornada == 2 ? status_asistencia_global_dia :
                    inventario.inv_idJornada == 3 ? status_asistencia_global_noche :
                    false;
                let valor = status_asistencia_global
                let texto = status_asistencia_global ? 'Verde' : 'Rojo';
                let opcion = _.find(filtroAnterior, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy('texto')
            .value()
        this.filtroSuspendidos =  _.chain(this.lista)
            .map(inventario => {
                let esSuspendido = false;
                if (inventario.inv_idJornada == 2) {
                    esSuspendido = inventario.inv_suspendido == 1 || inventario.ndia_idLider == 10;
                } else if (inventario.inv_idJornada == 3) {
                    esSuspendido = inventario.inv_suspendido == 1 || inventario.nnoche_idLider == 10;
                }
                let valor = esSuspendido;
                let texto = esSuspendido;
                let opcion = _.find(this.filtroSuspendidos, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        // ##### Filtro Clientes
        this.filtroClientes = _.chain(this.lista)
            .map(inventario => {
                let valor = inventario.cliente_idCliente
                let texto = inventario.cliente_nombreCorto

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroClientes, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy('valor')    // ordenado por numero de cliente
            .value()

    }
    reemplazarFiltro(nombreFiltro, filtroActualizado) {
        if (this[nombreFiltro]) {
            this[nombreFiltro] = filtroActualizado
        } else {
            console.error(`Filtro ${nombreFiltro} no existe.`)
        }
    }

    getListaFiltrada() {
        this.actualizarFiltros()
        let data = _.chain(this.lista)
        // Filtrar por Ceco
        .filter(inventario => {
            return _.find(this.filtroCeco, { 'valor': '' + inventario.local_ceco, 'seleccionado': true })
        })
        // Filtrar por Regiones
        .filter(inventario => {
            return _.find(this.filtroRegiones, { 'valor': inventario.local_cutRegion, 'seleccionado': true })
        })
        // Filtrar por Comunas
        .filter(inventario => {
            return _.find(this.filtroComunas, { 'valor': inventario.local_cutComuna, 'seleccionado': true })
        })
        // Filtrar por Turno
        .filter(inventario => {
            return _.find(this.filtroTurnos, { 'valor': inventario.inv_idJornada, 'seleccionado': true })
        })
        // Filtrar por Lideres
        .filter(inventario => {
            if (inventario.inv_idJornada == '1') {
                // la jornada no ha sido seleccionada, no hay ninguna nomina activa, entonces no hay lider seleccionado
                return true
            } else if (inventario.inv_idJornada == '2') {
                // si la jornada es de dia, revisar si el lider esta en la nomina_dia
                return _.find(this.filtroLideres, { 'valor': inventario.ndia_idLider, 'seleccionado': true })
            } else if (inventario.inv_idJornada == '3') {
                // si la jornada es 'noche', se debe buscar el lider en la nomina_noche
                return _.find(this.filtroLideres, { 'valor': inventario.nnoche_idLider, 'seleccionado': true })
            } else if (inventario.inv_idJornada == '4') {
                // si la jornada es 'dia y noche', se debe buscar el lider en la nomina_dia y nomina_noche
                return _.find(this.filtroLideres, { 'valor': inventario.ndia_idLider, 'seleccionado': true })
                    || _.find(this.filtroLideres, { 'valor': inventario.nnoche_idLider, 'seleccionado': true })
            }
        })
        // Filtrar por hora lider
        .filter(inventario => {
            if (inventario.inv_idJornada == '1') {
                // la jornada no ha sido seleccionada, no hay ninguna nomina activa, entonces no hay lider seleccionado
                return true
            } else if (inventario.inv_idJornada == '2') {
                // si la jornada es de dia, revisar si el lider esta en la nomina_dia
                return _.find(this.filtroHoraLider, { 'valor': inventario.ndia_hrLider, 'seleccionado': true })
            } else if (inventario.inv_idJornada == '3') {
                // si la jornada es 'noche', se debe buscar el lider en la nomina_noche
                return _.find(this.filtroHoraLider, { 'valor': inventario.nnoche_hrLider, 'seleccionado': true })
            } else if (inventario.inv_idJornada == '4') {
                // si la jornada es 'dia y noche', se debe buscar el lider en la nomina_dia y nomina_noche
                return _.find(this.filtroHoraLider, { 'valor': inventario.nnoche_hrLider, 'seleccionado': true })
                    || _.find(this.filtroHoraLider, { 'valor': inventario.nnoche_hrLider, 'seleccionado': true })
            }
        })
        // Filtrar por Supervisores
        .filter(inventario => {
            if (inventario.inv_idJornada == '1') {
                // la jornada no ha sido seleccionada, no hay ninguna nomina activa, entonces no hay supervisor seleccionado
                return true
            } else if (inventario.inv_idJornada == '2') {
                // si la jornada es de dia, revisar si el supervisor esta en la nomina_dia
                return _.find(this.filtroSupervisores, { 'valor': inventario.ndia_idSupervisor, 'seleccionado': true })
            } else if (inventario.inv_idJornada == '3') {
                // si la jornada es 'noche', se debe buscar el supervisor en la nomina_noche
                return _.find(this.filtroSupervisores, { 'valor': inventario.nnoche_idSupervisor, 'seleccionado': true })
            } else if (inventario.inv_idJornada == '4') {
                // si la jornada es 'dia y noche', se debe buscar el supervisor en la nomina_dia y nomina_noche
                return _.find(this.filtroSupervisores, { 'valor': inventario.ndia_idSupervisor, 'seleccionado': true })
                    || _.find(this.filtroSupervisores, { 'valor': inventario.nnoche_idSupervisor, 'seleccionado': true })
            }
        })
        // Filtrar por Captadores
        .filter(inventario => {
            if (inventario.inv_idJornada == '1') {
                // la jornada no ha sido seleccionada, no hay ninguna nomina activa, entonces no hay lider seleccionado
                return true
            } else if (inventario.inv_idJornada == '2') {
                // si la jornada es de dia, revisar si el lider esta en la nomina_dia
                //return _.find(this.filtroCaptadores, {'valor': inventario.ndia_idCaptador1, 'seleccionado': true})
                let caps = inventario.ndia_captadores.filter((captador) => {
                    let result = _.find(this.filtroCaptadores, { 'valor': captador.idUsuario, 'seleccionado': true })
                    if (result != undefined) {
                        return true;
                    }
                });
                return caps.length > 0;
            } else if (inventario.inv_idJornada == '3') {
                // si la jornada es 'noche', se debe buscar el lider en la nomina_noche
                let caps = inventario.nnoche_captadores.filter((captador) => {
                    let result = _.find(this.filtroCaptadores, { 'valor': captador.idUsuario, 'seleccionado': true })
                    if (result != undefined) {
                        return true;
                    }
                });
                return caps.length > 0;
                //return _.find(this.filtroCaptadores, {'valor': inventario.nnoche_idCaptador1, 'seleccionado': true})
            } else if (inventario.inv_idJornada == '4') {
                // si la jornada es 'dia y noche', se debe buscar el lider en la nomina_dia y nomina_noche
                /*return _.find(this.filtroCaptadores, {'valor': inventario.ndia_idCaptador1, 'seleccionado': true})
                    || _.find(this.filtroCaptadores, {'valor': inventario.nnoche_idCaptador1, 'seleccionado': true})*/
                let capsdia = inventario.ndia_captadores.filter((captador) => {
                    let result = _.find(this.filtroCaptadores, { 'valor': captador.idUsuario, 'seleccionado': true })
                    if (result != undefined) {
                        return true;
                    }
                });

                let capsnoche = inventario.nnoche_captadores.filter((captador) => {
                    let result = _.find(this.filtroCaptadores, { 'valor': captador.idUsuario, 'seleccionado': true })
                    if (result != undefined) {
                        return true;
                    }
                });
                return capsdia.length > 0 || capsnoche.length > 0;
            }
        })
        // Filtrar por Fecha (dejar de lo ultimo, ya que es la mas lenta -comparacion de strings-)
        .filter(inventario => {
            return _.find(this.filtroFechas, { 'valor': inventario.inv_fechaProgramada, 'seleccionado': true })
        })
        // Filtrar por Nominas
        .filter(inventario => {
            if (inventario.inv_idJornada == '1') {
                // la jornada no ha sido seleccionada, no hay ninguna nomina activa
                return true
            } else if (inventario.inv_idJornada == '2') {
                // si la jornada es de dia, revisar nomina de dia
                return _.find(this.filtroNominas, { 'valor': inventario.ndia_idEstadoNomina, 'seleccionado': true })
            } else if (inventario.inv_idJornada == '3') {
                // si la jornada es 'noche', revizar nomina_noche
                return _.find(this.filtroNominas, { 'valor': inventario.nnoche_idEstadoNomina, 'seleccionado': true })
            } else if (inventario.inv_idJornada == '4') {
                // si la jornada es 'dia y noche', se debe buscar nomina_dia y nomina_noche
                return _.find(this.filtroNominas, { 'valor': inventario.ndia_idEstadoNomina, 'seleccionado': true })
                    || _.find(this.filtroNominas, { 'valor': inventario.nnoche_idEstadoNomina, 'seleccionado': true })
            }
        })
        // Filtrar por Nominas Estado
        .filter(inventario => {
            if (inventario.inv_idJornada == '1') {
                // la jornada no ha sido seleccionada, no hay ninguna nomina activa
                return true
            } else if (inventario.inv_idJornada == '2') {
                // si la jornada es de dia, revisar nomina de dia
                return _.find(this.filtroNominasEstado, { 'valor': inventario.ndia_calificacionNomina, 'seleccionado': true })
            } else if (inventario.inv_idJornada == '3') {
                // si la jornada es 'noche', revizar nomina_noche
                return _.find(this.filtroNominasEstado, { 'valor': inventario.nnoche_calificacionNomina, 'seleccionado': true })
            } else if (inventario.inv_idJornada == '4') {
                // si la jornada es 'dia y noche', se debe buscar nomina_dia y nomina_noche
                return _.find(this.filtroNominasEstado, { 'valor': inventario.ndia_calificacionNomina, 'seleccionado': true })
                    || _.find(this.filtroNominasEstado, { 'valor': inventario.nnoche_calificacionNomina, 'seleccionado': true })
            }
        })
        // Filtrar por asistencia (VERDE / ROJO)
        .filter(inventario => {
            // Excluir al líder del cálculo de asistencia
            let titularesDia = inventario.ndia_totalTitulares
                .filter(row => !row.lider);
            let titularesNoche = inventario.nnoche_totalTitulares
                .filter(row => !row.lider);
            // Recalcular estado global (igual que en actualización)
            let status_asistencia_global_dia =
                titularesDia.length !== 0 &&
                titularesDia.every(row => row.estado_asistencia >= 3);
            let status_asistencia_global_noche =
                titularesNoche.length !== 0 &&
                titularesNoche.every(row => row.estado_asistencia >= 3);
            let status_asistencia_global =
                inventario.inv_idJornada == 2
                    ? status_asistencia_global_dia
                    : inventario.inv_idJornada == 3
                        ? status_asistencia_global_noche
                        : false;
            return _.find(this.filtroAsistencia, {
                valor: status_asistencia_global,
                seleccionado: true
            });
        })
        // Filtrar por Clientes
        .filter(inventario => {
            return _.find(this.filtroClientes, { 'valor': inventario.cliente_idCliente, 'seleccionado': true })
        })
        .filter(inventario => {
            return _.find(this.filtroEgreso, { 'valor': inventario.store_departureTime, 'seleccionado': true })
        })
        .filter(inventario => {
            return _.find(this.filtroUnidades, { 'valor': inventario.inv_unidadesReales > 0 ? 'Tiene Conteo' : 'Sin Conteo', 'seleccionado': true })
        })
        .filter(inventario => {
            let esSuspendido = false;
            if (inventario.inv_idJornada == 2) {
                esSuspendido = inventario.inv_suspendido == 1 || inventario.ndia_idLider == 10;
            } else if (inventario.inv_idJornada == 3) {
                esSuspendido = inventario.inv_suspendido == 1 || inventario.nnoche_idLider == 10;
            }
            return _.find(this.filtroSuspendidos, {'valor': esSuspendido, 'seleccionado': true});
        })
        .value();

        return {
            inventariosFiltrados: data,
            filtros: {
                filtroRegiones: this.filtroRegiones,
                filtroComunas: this.filtroComunas,
                filtroTurnos: this.filtroTurnos,
                filtroLideres: this.filtroLideres,
                filtroSupervisores: this.filtroSupervisores,
                filtroCaptadores: this.filtroCaptadores,
                filtroCeco: this.filtroCeco,
                filtroFechas: this.filtroFechas,
                filtroHoraLider: this.filtroHoraLider,
                filtroNominas: this.filtroNominas,
                filtroClientes: this.filtroClientes,
                filtroNominasEstado: this.filtroNominasEstado,
                filtroAsistencia: this.filtroAsistencia,
                filtroEgreso: this.filtroEgreso,
                filtroUnidades: this.filtroUnidades,
                filtroSuspendidos: this.filtroSuspendidos
            },
            checkNominas: data.map((inv) => {
                return { 
                    //id: inv.inv_idInventario,
                    nominaDia: {id: inv.ndia_idNomina, status: false},
                    nominaNoche: {id: inv.nnoche_idNomina, status: false}
                }
            })//[{ id: idInventario, status: status }]
        }
    }
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/BlackBoxIGSemanal.js